import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import GlassCard from '../ui/GlassCard';
import Button from '../ui/Button';

/**
 * Leaderboard card — weekly streak ranking.
 * Replaces inline styles from old HomePage.
 */
export default function LeaderboardCard({ leaderboard, userId, userRankData }) {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(true);

  return (
    <GlassCard accent className="leaderboard-card">
      <div className="leaderboard-header">
        <h3 className="leaderboard-title">🏆 Haftalık Streak Ligi</h3>
        <Button variant="ghost" size="sm" onClick={() => setVisible(!visible)}>
          {visible ? 'Gizle' : 'Göster'}
        </Button>
      </div>

      <AnimatePresence>
        {visible && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
          >
            {leaderboard.length === 0 ? (
              <div style={{ textAlign: 'center', padding: 'var(--space-4) 0' }}>
                <p className="text-muted text-sm">Liderlik tablosu şu anda boş. İlk sırayı kap!</p>
                <Button variant="primary" size="sm" onClick={() => navigate('/streaks')} style={{ marginTop: 'var(--space-3)' }}>
                  Streak Kazan
                </Button>
              </div>
            ) : (
              <div className="leaderboard-list">
                {leaderboard.map((user, index) => (
                  <motion.div
                    key={user.userId}
                    className={`leaderboard-row ${user.userId === userId ? 'leaderboard-row--me' : ''}`}
                    initial={{ opacity: 0, x: -10 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: index * 0.05 }}
                  >
                    <span className="leaderboard-rank">
                      {index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : `${index + 1}.`}
                    </span>
                    <span className="leaderboard-user">{user.userId === userId ? `${user.username} (Sen)` : user.username}</span>
                    <span className="leaderboard-score">{user.weeklyStreakPoints || 0} puan</span>
                  </motion.div>
                ))}

                {/* Kullanıcının Kendi Sırası (Eğer 10 dışındaysa) */}
                {userRankData && userRankData.rank > 10 && (
                  <motion.div
                    className="leaderboard-row leaderboard-row--me"
                    style={{ marginTop: 'var(--space-4)', border: '1px solid var(--accent-primary)' }}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                  >
                    <span className="leaderboard-rank">{userRankData.rank}.</span>
                    <span className="leaderboard-user">{userRankData.username} (Sen)</span>
                    <span className="leaderboard-score">{userRankData.weeklyStreakPoints || 0} puan</span>
                  </motion.div>
                )}
              </div>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </GlassCard>
  );
}
